import { Flame } from 'lucide-react';

const DISHES = [
  'Nyama Choma',
  'Ugali',
  'Sukuma Wiki',
  'Pilau',
  'Mandazi',
  'Githeri',
  'Mukimo',
  'Chapati',
  'Tilapia Fry',
  'Mutura',
  'Mahamri',
  'Kienyeji Chicken',
  'Chips Masala',
  'Kachumbari',
];

/** Scrolling strip of iconic Kenyan dishes between brand-stripe bands. */
export function Marquee() {
  const row = [...DISHES, ...DISHES];

  return (
    <div className="relative">
      <div className="brand-stripes h-2.5 w-full" aria-hidden />
      <div className="overflow-hidden bg-secondary py-3.5 text-secondary-foreground">
        <div className="flex w-max motion-safe:animate-marquee motion-reduce:animate-none">
          {row.map((dish, i) => (
            <span key={`${dish}-${i}`} className="flex items-center gap-6 pr-6" aria-hidden={i >= DISHES.length}>
              <span className="whitespace-nowrap font-display text-lg font-semibold italic tracking-wide">
                {dish}
              </span>
              <Flame className="size-4 shrink-0 text-marigold" />
            </span>
          ))}
        </div>
      </div>
      <div className="brand-stripes h-2.5 w-full" aria-hidden />
    </div>
  );
}
